<template>
  <div>
    <topTab ref="topTab" :tabData="tabData" @tabChange="changePages">
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="所属门店：">
          <el-select v-model="formInline.belongStoreKeyId" placeholder="请选择门店" clearable size="small">
            <el-option v-for="item in storeList" :label="item.value" :value="item.keyId" :key="item.keyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出库单号：">
          <el-input size="small" @keyup.enter.native="inputChange" v-model="formInline.outputStoreNo"
            placeholder="请输入出库单号"></el-input>
        </el-form-item>

        <el-form-item label="商品信息：">
          <el-cascader size="small" v-model="formInline.typeKeyId" :options="goodsTypeList" :props="cascaderProps"
            @change="handleTypeChange" placeholder="请选择商品信息" clearable filterable></el-cascader>
        </el-form-item>
        <el-form-item label="球镜">
          <el-select v-model="formInline.paramsKeyId1" placeholder="请选择球镜" clearable filterable size="small"
            @change="handleParamsChange">
            <el-option v-for="item in qiuJingList" :label="item.paramsValue" :value="item.keyId"
              :key="item.keyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="柱镜">
          <el-select v-model="formInline.paramsKeyId2" placeholder="请选择柱镜" clearable filterable size="small"
            @change="handleParamsChange">
            <el-option v-for="item in zhuJingList" :label="item.paramsValue" :value="item.keyId"
              :key="item.keyId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设置价格：">
          <el-select v-model="formInline.setPrice" placeholder="请选择是否设置价格" size="small" @change="handleParamsChange">
            <el-option label="全部" :value="0"></el-option>
            <el-option label="已设置" :value="1"></el-option>
            <el-option label="未设置" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出库时间：">
          <el-date-picker clearable v-model="dateValue" size="small" type="daterange" value-format="yyyy-MM-dd"
            format="yyyy-MM-dd" @change="handleDateChange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="顾客姓名：">
          <el-input size="small" @keyup.enter.native="inputChange" v-model="formInline.customerName"
            placeholder="请输入顾客姓名"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button v-if="this.$checkBtnPermission('/outputStoreDtl/index', 'viewPage')" size="small" type="primary"
            class="el-icon-search" @click="inputChange()">
            搜索
          </el-button>
          <el-button v-if="this.$checkBtnPermission('/outputStoreDtl/index', 'reset')" size="small"
            icon="el-icon-refresh" @click="clearAll">重置</el-button>
          <el-button v-if="this.$checkBtnPermission('/outputStoreDtl/index', 'export')" size="small" type="warning"
            icon="el-icon-s-promotion" @click="handleExportDtlData()">导出</el-button>
          <el-button v-if="
            this.$checkBtnPermission('/outputStoreDtl/index', 'editPrice')
          " size="small" type="danger" icon="el-icon-edit" @click="handleEditPriceMoney()">修改单价</el-button>
        </el-form-item>
        <el-form-item style="float: right; margin-right: 0">
          <my-column-filter :listColumns="listColumns" @hidePop="getCheckBox"></my-column-filter>
        </el-form-item>
      </el-form>
      <STable :columns="columnsData" :data="listData" @getData="getListData" :loading="loading"
        @selection-change="handleSelectionChange" border>
        <el-table-column slot="customerInfo.gender" label="性别" width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.customerInfo.gender === 1 ? "男" : "女" }}
          </template>
        </el-table-column>
        <el-table-column v-if="isShowMoney" slot="price" label="单价" width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.price }}
          </template>
        </el-table-column>
        <el-table-column v-if="isShowMoney" slot="money" label="金额" width="100" align="center" fixed="left">
          <template slot-scope="scope">
            {{ scope.row.money }}
          </template>
        </el-table-column>
      </STable>
      <!-- 分页组件 -->
      <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </topTab>
    <my-dialog title="修改单价" dialogType="form" :visible.sync="showEditPriceDialog" :close-on-click-modal="false"
      @close="closeEditPriceDialog">
      <div style="width: 60%; margin: 0 auto">
        <el-form label-width="8.75rem" class="demo-form-inline" align="center" inline>
          <el-form-item label="单价" prop="price">
            <el-input-number class="input_200px" size="small" type="number" :step="0.01" :min="0"
              v-model.number="price">
            </el-input-number>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeEditPriceDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="saveEditPriceloading" class="title" @click="saveEditPrice()">
          保存
        </el-button>
      </div>
    </my-dialog>
  </div>
</template>

<script>
import {
  GetOutputStoreDtlPageList,
  ExportOutputStoreDtl,
  SaveOutputStoreDtlEditPrice,
} from "@/api/receiptApi.js";
import {
  GetAllGoodsTypeTreePageList,
  GetGoodsParamsList,
} from "@/api/baseDataApi.js";
import { GetOrganizationListByConfig } from "@/api/organizationalApi.js";
import { downloadFile } from "@/utils/export.js";
export default {
  data() {
    return {
      activeTab: "1",
      tabData: [
        {
          key: "1",
          value: "出库明细列表",
        },
      ],
      pageShow: true,
      loading: false, // 显示加载
      listData: [],
      // 分页参数
      pageparm: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      },
      selectionRowKeyIds: [],
      storeList: [],
      goodsTypeList: [],
      qiuJingList: [],
      zhuJingList: [],
      cascaderProps: {
        value: "keyId", // 绑定值的属性名
        label: "name", // 显示文本的属性名
        children: "subList", // 子节点的属性名
        checkStrictly: false, // 可以选择任意一级
        expandTrigger: "click", // 展开方式
      },
      dateValue: [],
      formInline: {
        pageIndex: 1,
        pageSize: 10,
        typeKeyId: "",
        paramsKeyId1: "",
        paramsKeyId2: "",
        startTime: null,
        endTime: null,
        outputStoreNo: "",
        belongStoreKeyId: "",
        setPrice: 0,
        customerName: "",
      },
      columnsData: [], //显示列
      listColumns: [
        {
          prop: "keyId",
          label: "全选",
          align: "center",
          fixed: "left",
          width: "55",
          isKeep: true,
          selection: true,
        },
        {
          prop: "rowNumber",
          label: "序号",
          align: "center",
          fixed: "left",
          width: "80",
          isKeep: true,
        },
        {
          prop: "belongStoreName",
          label: "所属门店",
          align: "center",
          fixed: "left",
          isKeep: true,
          width: "150",
        },
        {
          prop: "customerInfo.name",
          label: "顾客姓名",
          align: "center",
          width: "80",
          fixed: "left",
          isKeep: true,
        },
        {
          prop: "goodsInfo.type",
          label: "商品品牌",
          align: "center",
          fixed: "left",
          isKeep: true,
          width: "120",
        },
        {
          prop: "goodsInfo.name",
          label: "商品名称",
          align: "center",
          width: "160",
          fixed: "left",
          isKeep: true,
        },
        {
          prop: "goodsInfo.qiuJing",
          label: "球镜",
          align: "center",
          width: "80",
          fixed: "left",
          isKeep: true,
        },
        {
          prop: "goodsInfo.zhuJing",
          label: "柱镜",
          align: "center",
          width: "80",
          fixed: "left",
          isKeep: true,
        },
        {
          slot: "money",
          label: "金额",
          align: "center",
          width: "100",
          fixed: "left",
        },
        {
          prop: "outputStoreNo",
          label: "出库单号",
          align: "center",
          width: "230",
        },
        {
          prop: "outputDate",
          label: "出库日期",
          align: "center",
          width: "180",
        },
        {
          prop: "outputStateStr",
          label: "出库类型",
          align: "center",
          width: "120",
        },
        {
          prop: "jjInformation",
          label: "镜架信息",
          align: "center",
          minWidth: "120",
        },
        {
          prop: "machinTypeStr",
          label: "加工类型",
          align: "center",
          minWidth: "120",
        },
        {
          slot: "price",
          label: "单价",
          align: "center",
          width: "80",
        },
        {
          prop: "quantity",
          label: "数量",
          align: "center",
          width: "80",
        },
        {
          prop: "remark",
          label: "ADD",
          align: "center",
          minWidth: "180",
        },
        {
          slot: "customerInfo.gender",
          label: "顾客性别",
          align: "center",
          width: "80",
        },
        {
          prop: "customerInfo.age",
          label: "顾客年龄",
          align: "center",
          width: "80",
        },
        {
          prop: "creator",
          label: "创建人",
          align: "center",
          minWidth: "80",
        },
        {
          prop: "createTime",
          label: "创建时间",
          align: "center",
          minWidth: "160",
        },
        {
          prop: "editor",
          label: "维护人",
          align: "center",
          minWidth: "80",
        },
        {
          prop: "updateTime",
          label: "维护时间",
          align: "center",
          minWidth: "160",
        },
        // {
        //   operation: true,
        //   isKeep: true,
        //   label: "操作",
        //   btnGroup: [
        //     {
        //       icon: "el-icon-delete",
        //       name: "删除",
        //       type: "4",
        //       btnType: "danger",
        //     },
        //   ],
        // },
      ],
      isShowMoney: false,
      price: 0,
      saveEditPriceloading: false,
      showEditPriceDialog: false,
    };
  },
  // 注册组件
  components: {},
  created() {
    // 初始列
    this.getCheckBox(this.listColumns.map((item) => item.label));
    this.getListData();
    this.GetAllGoodsTypeTreePageList();
    this.GetGoodsParamsList();
    this.GetOrganizationListByConfig();

    let userdata = JSON.parse(localStorage.getItem("userdata"));
    if (userdata.roleInfo.keyId == "2f91e757a9c4444dbe13146a363a717c") {
      this.isShowMoney = true;
    } else {
      this.isShowMoney = false;
    }
  },
  computed: {},
  methods: {
    // 获取筛选框
    getCheckBox(val) {
      let arr = this.listColumns.filter((v) => !val.includes(v.label));
      this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
    },
    changePages() { },
    handleDateChange(val) {
      if (val) {
        this.formInline.startTime = val[0];
        this.formInline.endTime = val[1];
      } else {
        this.formInline.startTime = null;
        this.formInline.endTime = null;
      }
    },
    // 获取列表
    getListData() {
      this.loading = true;
      GetOutputStoreDtlPageList(this.formInline)
        .then((res) => {
          if (res.code == 1) {
            this.loading = false;
            this.listData = res.data;
            this.pageparm.total = res.totalNumber;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    // 重置
    clearAll() {
      this.$data.formInline = this.$options.data.call(this).formInline;
      this.search();
    },
    inputChange(val) {
      this.search();
    },
    // 分页插件事件
    callFather(parm) {
      if (parm.currentPage == undefined) {
        this.formInline.pageIndex = 1;
      } else {
        this.formInline.pageIndex = parm.currentPage;
      }
      this.formInline.pageSize = parm.pageSize;
      this.getListData();
    },
    // 搜索事件
    search() {
      this.formInline.pageIndex = 1;
      this.pageShow = false;
      this.$nextTick(() => {
        this.pageShow = true;
      });
      this.getListData();
    },
    // 处理商品类型选择变化
    handleTypeChange(value) {
      if (value && value.length > 0) {
        // 取最后一级的值作为typeKeyId
        this.formInline.typeKeyId = value[value.length - 1];
      } else {
        this.formInline.typeKeyId = "";
      }
      this.search();
    },
    // 获取商品类型数据
    GetAllGoodsTypeTreePageList() {
      GetAllGoodsTypeTreePageList({})
        .then((res) => {
          if (res.code == 1) {
            this.goodsTypeList = res.data;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    //获取商品参数信息
    GetGoodsParamsList() {
      GetGoodsParamsList({})
        .then((res) => {
          if (res.code == 1) {
            this.qiuJingList = res.data.filter((item) => item.type == 1);
            this.zhuJingList = res.data.filter((item) => item.type == 2);
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    // 处理商品参数选择变化
    handleParamsChange(value) {
      this.search();
    },
    // 获取所属门店
    GetOrganizationListByConfig() {
      const paramer = {
        key: 1,
      };
      GetOrganizationListByConfig(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.storeList = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取门店信息失败!");
        });
    },
    // 导出筛选的数据
    handleExportDtlData() {
      ExportOutputStoreDtl(this.formInline)
        .then((res) => {
          if (res.code == 1) {
            let fileName = res.data
              ? res.data.substring(res.data.lastIndexOf("/") + 1)
              : "出库单明细信息导出.xlsx";
            downloadFile(res.data, fileName);
            this.$message({
              type: "success",
              message: "导出成功！",
            });
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("导出失败，请稍后再试！");
        });
    },
    // 选择行
    handleSelectionChange(val) {
      this.selectionRowKeyIds = val.map((item) => item.keyId);
    },
    // 修改单价金额
    handleEditPriceMoney() {
      if (this.selectionRowKeyIds.length === 0) {
        this.$message({
          type: "warning",
          message: "请选择要修改的出库明细信息！",
        });
        return;
      }
      this.showEditPriceDialog = true;
    },
    // 关闭修改单价弹窗
    closeEditPriceDialog() {
      this.showEditPriceDialog = false;
      this.price = 0;
    },
    // 保存单价信息
    saveEditPrice() {
      if (this.price == 0) {
        this.$message({
          type: "warning",
          message: "请输入单价！",
        });
        return;
      }
      let params = {
        keyIds: this.selectionRowKeyIds,
        price: this.price,
      };
      this.saveEditPriceLoading = true;
      SaveOutputStoreDtlEditPrice(params)
        .then((res) => {
          if (res.code == 1) {
            this.$message({
              type: "success",
              message: "修改成功！",
            });
            this.closeEditPriceDialog();
            this.getListData();
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .finally(() => {
          this.saveEditPriceLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.one_1 {
  padding: 2px 20px;
  background: #e6f7ff;
  border: 1px solid #6acaf3;
  color: #56bbfd;
  border-radius: 2px;
}

.one_2 {
  padding: 2px 20px;
  background: #fcd4ff;
  border: 1px solid #dfbce2;
  color: #ea7cff;
  border-radius: 2px;
}
</style>